import React  from "react"

export function PostPreview({ hit, components }) {
  return (
    <a href={'/news/' + hit.slug} className="aa-ItemLink">
      <div className="py-4 leading-loose">
        <div className="font-semibold">
          <components.Highlight hit={hit} attribute="title" tagName="mark" />
        </div>
        <div className="">
          <components.Highlight
            hit={hit}
            attribute="description"
            tagName="mark"
          />
        </div>
      </div>
    </a>
  )
}
